import * as React from 'react'
import ContentLoader from 'react-content-loader'
import { TextLoaderContainer } from './style'
import { Icon } from './style'

export const TextLoader: React.FC = () => (
  <TextLoaderContainer>
    <ContentLoader
      height={42}
      width={500}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      style={{ height: '32px', width: '100%' }}
    />
  </TextLoaderContainer>
)

export const CircleIconLoader: React.FunctionComponent = () => (
  <Icon>
    <ContentLoader
      height={70}
      width={70}
      speed={2}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
      style={{ height: '86px' }}
    >
      <circle cx="35" cy="38" r="30" />
    </ContentLoader>
  </Icon>
)
